const config = {
  APIUrl: "/prod/",
  ImageUrl: "https://herbariumnsw-pds.s3.ap-southeast-2.amazonaws.com/images/",
};

export default config;
